import React from "react";
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  EditButton,
  TextInput,
  
  ReferenceInput,
  SelectInput,
  translate,
  FunctionField,
  DateTimeInput,
  DateField,
  Show,
  SimpleShowLayout,

  ListButton,
  Filter
} from "react-admin";
import CheckboxInput from "../../inputs/CheckboxInput";
import { CardActions } from "@material-ui/core";
import {
    required,
    password,
    passwordEdit,
    passwordEquals
} from "../../validators/validators";

const SettingFilter = props => (
  <Filter {...props}>
    <TextInput label="resources.misc.fields.id" source="id" />
  </Filter>
);

export const SettingList = props => (
  <List {...props} exporter={false} filters={<SettingFilter />} bulkActionButtons={false}>
    <Datagrid>
      <TextField label="resources.misc.fields.id" source="id" />
      <TextField label="resources.misc.fields.s1" source="s1" />
      <TextField label="resources.misc.fields.s2" source="s2" />
      <TextField label="resources.misc.fields.s3" source="s3" />
      <EditButton label="" /> 
    </Datagrid>
  </List>
);

const SettingTitle = ({ record }) => {
    return (
      <span>Setting {record ? `"${record.id}"` : ""}</span>
    );
};

const cardActionStyle = {
    zIndex: 2,
    display: "inline-block",
    float: "right"
};

const Actions = ({ basePath, data, refresh }) => (
  <CardActions style={cardActionStyle}>
    <EditButton basePath={basePath} record={data} />
    <ListButton basePath={basePath} />
  </CardActions>
);

export const SettingShow = props => (
  <Show title={<SettingTitle />} actions={<Actions />} {...props}>
    <SimpleShowLayout>
      <TextField label="resources.misc.fields.id" source="id" />
      <TextField label="resources.misc.fields.s1" source="s1" />
      <TextField label="resources.misc.fields.s2" source="s2" />
      <TextField label="resources.misc.fields.s3" source="s3" />
    </SimpleShowLayout>
  </Show>
);

export const SettingEdit = ({ permissions, ...props }) => (
  <Edit title={<SettingTitle />} actions={<CardActions />} {...props}>
    <SimpleForm>
      <TextInput
        disabled
        label="resources.misc.fields.id"
        source="id"
      />
      <CheckboxInput
        label="resources.misc.fields.s1"
        source="s1"
      />
      <CheckboxInput
        label="resources.misc.fields.s2"
        source="s2"
      />
      <CheckboxInput
        label="resources.misc.fields.s3"
        source="s3"
      />
    </SimpleForm>
  </Edit>
);

export const SettingCreate = ({ permissions, ...props }) => (
  <Create title="Nova nastavitev" {...props}>
    <SimpleForm redirect="list">
      <CheckboxInput
        label="resources.misc.fields.s1"
        source="s1"
      />
      <CheckboxInput
        label="resources.misc.fields.s2"
        source="s2"
      />
      <CheckboxInput
        label="resources.misc.fields.s3"
        source="s3"
      />
    </SimpleForm>
  </Create>
);